import { FC } from 'react';

import { IonSkeletonText } from '@ionic/react';

import { Card } from '../../Card/Card';

import styles from '../Skeleton.module.scss';

interface SkeletonListProps {
  count?: number;
}

export const SkeletonList: FC<SkeletonListProps> = ({ count }) => {
  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <Card key={index} className={styles.baseRoot}>
          <Card.Content className={styles.listContent}>
            <div className={styles.baseText}>
              <IonSkeletonText className={styles.skeleton} animated />
              <IonSkeletonText className={styles.skeleton} animated />
            </div>
          </Card.Content>
        </Card>
      ))}
    </>
  );
};
